// src/components/layout/FilterBar.jsx
import React from 'react';
import { RotateCcw, Loader2 } from 'lucide-react'; // 🌟 Search 대신 RotateCcw 임포트

export function FilterBar({ 
  children, // 왼쪽 필터 입력 요소들
  actions,  // 오른쪽 부가 액션 버튼들 (등록, 삭제, 엑셀 등)
  onReset,  // 🌟 onSearch 대신 onReset으로 프롭명 변경
  isSearching = false 
}) {
  return (
    <div className="flex flex-col gap-4 rounded-xl border border-slate-200 bg-white p-5 shadow-sm lg:flex-row lg:items-end lg:justify-between w-full mb-6">
      {/* 1. 필터 영역 */}
      <div className="flex flex-1 flex-col gap-4 md:flex-row md:items-end w-full lg:w-auto">
        {children}
      </div>

      {/* 2. 액션 버튼 영역 */}
      <div className="flex items-center gap-2.5 pt-4 lg:pt-0 shrink-0 flex-wrap">
        {/* 🌟 초기화 버튼으로 변경 (디자인도 보조 버튼 스타일로 수정) */}
        <button 
          onClick={onReset} 
          disabled={isSearching}
          className="flex h-10 items-center gap-2 rounded-lg border border-slate-300 bg-white px-4 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50 transition-colors whitespace-nowrap disabled:opacity-50"
        >
          {isSearching ? <Loader2 className="h-4 w-4 animate-spin text-slate-400" /> : <RotateCcw className="h-4 w-4 text-slate-500" />} 초기화
        </button>
        
        {actions}
      </div>
    </div>
  );
}